import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import { Dialog, OutlinedInput, Typography, Stack, Box } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import ApiService from "../../services/api-service";
import Loader from "./../../components/Loader";
import notifier from "./../../components/Notifier";
import { Upload, Calendar, Plus, Lock } from "react-iconly";
import "./index.scss";
import { disableDates, getErrorString } from "../../constants/function";
import { useTranslation } from "react-i18next";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AuctionPopup(props) {
  const { t } = useTranslation("common");
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [amount, setAmount] = React.useState("");
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [fraction, setFraction] = useState();
  const [fractions, setFractions] = useState({});
  //bid
  const bid = async () => {
    if (!validateDates(startDate, endDate)) {
      notifier.error(t("invalidDate"));
      return;
    }
    try {
      const payload = {
        startingPrice: amount,
        startDate: startDate,
        endDate: endDate,
        type: props["type"] ? props["type"] : "playlist",
      };
      if (props["type"] && props["type"] === "music") {
        payload["assetId"] = props["assetId"];
        payload["rank"] = fraction;
      } else {
        payload["assetId"] = props["assetId"];
        payload["rank"] = 1;
      }
      setLoading(true);
      const response = await ApiService.AUCTION_NFT_V2(payload);

      setLoading(false);
      notifier.success(t("notifier.success.toast15"));
      props.handleClose({ amount: amount });
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };

  const validateDates = (startDate, endDate) => {
    const sDate = new Date(startDate);
    const eDate = new Date(endDate);

    if (sDate > eDate) {
      return false;
    }

    if (sDate < new Date().setHours(0, 0, 0, 0)) {
      return false;
    }
    return true;
  };

  const getNftFractions = async (assetId) => {
    try {
      setFractions({});
      setIsLoading(true);
      const response = await ApiService.GET_NFT_FRACTIONS(
        `${assetId}&onAuction=false`
      );
      setFractions({ ...response["result"] });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const handleSelect = (fr, i) => {
    setFraction(fr == fraction ? null : fr);
  };
  React.useEffect(() => {
    if (document.getElementById("auctionFrom")) {
      disableDates("auctionFrom");
    }
  }, [amount]);
  useEffect(() => {
    if (props["type"] === "music" && props["isMaster"])
      getNftFractions(props["assetId"]);
    else setFraction(props["rank"]);
  }, []);
  const currentDate = new Date().toISOString().split("T")[0];
  return (
    <div>
      <Dialog
        open={props.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => props.handleClose(false)}
        PaperProps={{
          style: {
            // backgroundColor: "#1E1E1E",
            backgroundColor: "#171515",
            backgroundImage: "none",
            boxShadow: "none",
            color: "#000000",
            borderRadius: 16,
            padding: 16,
            maxHeight: "80vh",
          },
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <Stack spacing={1}>
          <Stack>
            {props["type"] === "music" && props["isMaster"] ? (
              <Box className="__sell_nft_fractions">
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  sx={{ paddingTop: "20px" }}
                >
                  <Typography className="fs-17">
                    {t("auctionPopup.text1")}
                  </Typography>
                  <Typography className="fs-17">
                    {fractions["availableFractions"] || 0}/
                    {fractions["totalFractions"] || 0}
                  </Typography>
                </Stack>
                <Stack
                  className="_nft_fractions_box"
                  sx={{ maxHeight: "70% !important" }}
                >
                  {fractions["fractions"] &&
                    fractions["fractions"].map((f, index) => (
                      <Typography
                        onClick={() => handleSelect(f, index)}
                        className={
                          "_fraction " +
                          (fraction === f ? "_fraction_selected" : "")
                        }
                        key={index}
                      >
                        {f}
                      </Typography>
                    ))}
                </Stack>
                {isLoading ? (
                  <Loader _class="__loader_inside" wait="true" />
                ) : null}
              </Box>
            ) : null}
            <Typography className="fs-14" mb="5px !important">
              {t("auctionPopup.text2")}
            </Typography>
            <DialogContent sx={{ padding: 0 }}>
              <OutlinedInput
                sx={{
                  backgroundColor: "background: #262626 !important",
                  width: "100%",
                }}
                type="number"
                autoFocus
                margin="dense"
                id="name"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                onKeyDown={(e) =>
                  ["e", "E", "+", "-", "."].includes(e.key) &&
                  e.preventDefault()
                }
                placeholder={t("auctionPopup.text3")}
                autoComplete="off"
                endAdornment={
                  <Typography
                    sx={{
                      color: "#FFFFFF50 !important",
                      padding: "5px",
                      fontSize: "12px !important",
                    }}
                  >
                    {t("auctionPopup.text4")}
                  </Typography>
                }
              />
            </DialogContent>
          </Stack>
          <Stack>
            <Typography className="fs-14">{t("auctionPopup.text5")}</Typography>
            <DialogContent sx={{ padding: 0 }}>
              <Box className="__upload_inputbox">
                <input
                  id="auctionFrom"
                  min={currentDate}
                  style={{ border: 0, width: "95%" }}
                  type="date"
                  className="__input date-click _cp"
                  placeholder={t("auctionPopup.text5")}
                  value={startDate}
                  onChange={(e) => {
                    setStartDate(e.currentTarget.value);
                    disableDates(
                      "auctionEnddate",
                      "min",
                      e.currentTarget.value
                    );
                  }}
                  // disabled={!amount}
                />

                <Calendar
                  className="__input_icon _cp"
                  set="light"
                  primaryColor="white"
                />
              </Box>
            </DialogContent>
          </Stack>
          <Stack>
            <Typography className="fs-14">{t("auctionPopup.text6")}</Typography>
            <DialogContent sx={{ padding: 0 }}>
              <Box className="__upload_inputbox">
                <input
                  id="auctionEnddate"
                  style={{ border: 0, width: "95%" }}
                  type="date"
                  className="__input date-click _cp"
                  placeholder={t("auctionPopup.text6")}
                  value={endDate}
                  onChange={(e) => setEndDate(e.currentTarget.value)}
                  disabled={!startDate}
                />

                <Calendar
                  className="__input_icon"
                  set="light"
                  primaryColor="white"
                />
              </Box>
            </DialogContent>
          </Stack>
          <DialogActions sx={{ justifyContent: "space-between" }}>
            <Button
              sx={{ maxWidth: "150px", padding: "10px 35px" }}
              color="default"
              onClick={() => props.handleClose(false)}
            >
              {t("auctionPopup.button1")}
            </Button>
            <Button
              sx={{ maxWidth: "150px", padding: "10px 35px" }}
              variant="contained"
              color="primary"
              onClick={bid}
              disabled={
                props["type"] === "music"
                  ? !amount || !fraction || !startDate || !endDate
                  : !amount || !startDate || !endDate
              }
            >
              {t("auctionPopup.button2")}
            </Button>
          </DialogActions>
        </Stack>
      </Dialog>
      {loading ? <Loader wait={true} /> : null}
    </div>
  );
}
